module.exports = __webpack_public_path__ + "static/media/goodness.118b5e98.jpeg";